__turbopack_context__.v({
  "container": "CTASection-module__nYd27q__container",
  "ctaCard": "CTASection-module__nYd27q__ctaCard",
  "eyebrow": "CTASection-module__nYd27q__eyebrow",
  "section": "CTASection-module__nYd27q__section",
  "title": "CTASection-module__nYd27q__title",
});
